import React, { useState } from 'react';
import { FaExclamationTriangle } from "react-icons/fa";
import { FaChevronDown } from "react-icons/fa6";
import { Link, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import apis from '../services';
import { SyncLoader } from 'react-spinners';
import { IoIosArrowBack } from 'react-icons/io';
import { ImCross } from 'react-icons/im';
import DynamicHeader from '../Header/DynamicHeader';

const blockchainOptions = [
  { value: "1", label: "Ethereum" },
  { value: "101", label: "Solana" },
  { value: "56", label: "Binance" },
  { value: "43114", label: "Avalanche" },
  { value: "137", label: "Polygon" },
];

const blockchainToNetwork = {
  "1": "eth",
  "101": "solana",
  "56": "bsc",
  "43114": "avax",
  "137": "polygon_pos"
};

const CheckScam = () => {
  const [tokenAddress, setTokenAddress] = useState('');
  const [blockchain, setBlockchain] = useState('1');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleInputChange = (e) => setTokenAddress(e.target.value);
  const handleBlockchainChange = (e) => setBlockchain(e.target.value);

  const removeTokenAddressAndData = () => {
    localStorage.removeItem("token-address");
    localStorage.removeItem("token-data");
  };

  const handleCheckScam = async () => {
    setLoading(true);
    try {
      const network = blockchainToNetwork[blockchain];
      if (!network) {
        toast.error('Invalid blockchain selected.');
        setLoading(false);
        return;
      }
      const response = await apis.getDetails(tokenAddress, blockchain, network);

      if (response.status === 200) {
        localStorage.setItem("token-address", JSON.stringify(tokenAddress));
        localStorage.setItem("token-data", JSON.stringify(response.data));
        navigate(`/details/${tokenAddress}?checkScam=true&&chainName=${network}`, { state: { tokenData: response.data } });
      } else {
        removeTokenAddressAndData();
        toast.error('Invalid response from API');
      }
    } catch (err) {
      removeTokenAddressAndData();
      if (err.response?.status === 404) {
        toast.error('Record not found, will get back shortly');
        navigate(`/details/${tokenAddress}?checkScam=true`, { state: { error: 'Token data not found.' } });
      } else {
        toast.error(err.response?.data?.message || 'Something went wrong.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
  <div>
        {/* <div className="header-container">
          <div className="header-content">
            <h2 className="header-subtitle">
              <span className="color-sp-lookna"> Lookna </span><br></br><br></br>
              
              FIND YOUR<span className="color-sp"> IDEAL INVESTMENT </span>VAULT
  
            </h2>
          
          </div>
          <div className="details-borders"></div>
       
        </div>
  */}
  <DynamicHeader/>
    <div className="checkscam-overlay">
   
      <div style={{height: "90px"}}></div>
      <ToastContainer />
      <div className="checkscam-modal">
      <div style={{textAlign : "justify" , border : "none" , backgroundColor : "transparent"}}>
            <Link to={"/home"}>
              <button type="submit" style={{background : "transparent" , border : "none"}}>
                <ImCross color='white' cursor= "pointer" /> 
              </button>
            </Link>
          </div>
        <h2 className="checkscam-title">
              
          CHECK SCAMMER<br />IDENTIFIER
        </h2>
        <div className="checkscam-form">
          <div className="checkscam-chain-select-wrapper">
            <select
              className="checkscam-chain-select"
              value={blockchain}
              onChange={handleBlockchainChange}
            >
              <option value="" disabled>
                Please select your preferred chain
              </option>
              {blockchainOptions.map(opt => (
                <option key={opt.value} value={opt.value}>{opt.label}</option>
              ))}
            </select>
            <FaChevronDown className="checkscam-chevron" />
          </div>
          <input
            type="text"
            className="checkscam-input"
            placeholder="Token Address"
            value={tokenAddress}
            onChange={handleInputChange}
          />
          <button
            className="checkscam-button"
            onClick={handleCheckScam}
            disabled={loading || !tokenAddress}
          >
            {loading ? (
          <SyncLoader color="white" size={9} /> 
            ) : (
              <>
                <FaExclamationTriangle className="checkscam-icon" />
                Check Scam
              </>
            )}
          </button>
        </div>
      </div>
    </div>
     </div>
  );
};

export default CheckScam;
